import * as React from 'react';
import Helmet from 'react-helmet';

import { withIntl, IntlProps } from 'ha/i18n';
import { APOLLO_SUPPLY_LANDING } from 'ha/constants/pageNames';
import Page from 'ha/modules/Page';
import { HermesProps } from 'ha/modules/Hermes';
import BlogInfo from 'ha/types/apollo/BlogInfo';
import MediaQuery from 'ha/helpers/MediaQuery';
import Breadcrumbs from 'ha/components/Breadcrumbs';
import AboveTheFold from '../containers/AboveTheFold';
import Benefits from './Benefits';
import Steps from './Steps';
import Info from '../containers/Info';
import Testimonials from './Testimonials';
import CTABlock from '../containers/CTABlock';
import Icons from './Icons';
import ContactForm from './ContactForm';
import FAQ from './FAQ';

interface Data {
  blogList?: Array<Pick<BlogInfo, 'title' | 'pathname'>>;
  title?: string;
  meta?: {
    description?: string;
  };
}

export const SupplyLandingPage: React.SFC<HermesProps<Data> & IntlProps> = ({
  data: { blogList, title, meta = {} },
  route,
  intl: { urlResolver, T },
}) => (
  <Page
    includeLegacyIconFont
    name={title || APOLLO_SUPPLY_LANDING}
    category={APOLLO_SUPPLY_LANDING}
    hideIntercom
    isLandingPage
    hasFooter={false}
    breadcrumbs={
      <Breadcrumbs
        breadcrumbs={[
          {
            name: T('Become an advertiser'),
            path: urlResolver.absolutizePath(route.pathname, {
              skipAddLanguage: true,
            }),
          },
        ]}
        withJsonLDSchema
        withoutFirstSeparator={false}
      />
    }
  >
    <MediaQuery>
      {({ md }) => (
        <div>
          <Helmet titleTemplate="%s | HousingAnywhere">
            {title && <title>{title}</title>}
            {title && <meta property="og:title" content={title} />}
            {meta.description && (
              <meta name="description" content={meta.description} />
            )}
            {meta.description && (
              <meta property="og:description" content={meta.description} />
            )}
            <link
              rel="canonical"
              href={urlResolver.absolutizePath(route.props.canonical, {
                skipAddLanguage: true,
              })}
            />
          </Helmet>
          <AboveTheFold />
          <Benefits />
          <Steps />
          <Info />
          <Testimonials />
          <CTABlock />
          {md && <Icons />}
          <ContactForm />
          {blogList && blogList.length > 0 && (
            <FAQ
              questions={blogList.map(blog => ({
                text: blog.title,
                url: blog.pathname,
              }))}
            />
          )}
        </div>
      )}
    </MediaQuery>
  </Page>
);

export default withIntl(SupplyLandingPage);
